import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getMyTodayAppointmentsRequest } from '../../../store/appointments/actions';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import './home.scss';
import InfiniteScroll from 'react-infinite-scroller';

function MyTodayAppointments({ intl: { messages } }) {
    const dispatch = useDispatch();
    const { myTodayAppointments } = useSelector((state) => state.appointments);
    const [myPage, setMyPage] = useState(1);

    useEffect(() => {
        dispatch(getMyTodayAppointmentsRequest({date: moment().format('YYYY-MM-DD')}));
    }, [dispatch]);
  
    // if (!data) return null

    const loadFunc = (page) => {
        setMyPage(page);
        dispatch(getMyTodayAppointmentsRequest({page: page, date: moment().format('YYYY-MM-DD')}));
    }

    return (
        <div className='myapps_container'>
            <h3>{messages.home.myappointments}</h3>
            <div className="scrollbar" id="style-4" style={{ height: 440 }} >
            { myTodayAppointments?.data ? (
                    <InfiniteScroll
                        pageStart={1}
                        loadMore={(page) => loadFunc(page)}
                        hasMore={myPage < myTodayAppointments?.last_page}
                        loader={<div className="loader" key={0}>Loading ...</div>}
                        useWindow={false}
                    >
                        { 
                            myTodayAppointments?.data?.map((item, index) => {
                                return (
                                    <div key={index} style={{ height: 60 }} className={`myapps_item ${parseInt(item.purpose) === 1 ? 'textual' : parseInt(item.purpose) === 2 ? 'call' : parseInt(item.purpose) === 3 ? 'video' : parseInt(item.purpose) === 4 ? 'atOffice' : '' }`}>
                                        <div className='myapps_item_date'>{moment(item.start_date).format('h:mm a')}</div>
                                        <div className='myapps_item_title'>
                                            <span>{item.patient_name}</span>
                                            <span>{item.purpose_name}</span>
                                        </div>
                                    </div>
                                    
                                )
                            })
                        }
                    </InfiniteScroll>
                ) : null
            }
            </div>
        </div>
    )
}

export default injectIntl(MyTodayAppointments)